import { useMemo } from "react"
import { useParams } from "react-router-dom"
import { Uuid } from "types"
import { usePageData } from "./usePageData"

export const useDetailData = () => {
    const { slug } = usePageData()
    const params = useParams() as { id?: Uuid }

    const pageTitle = useMemo(() => {
        return params?.id ? "Редактирование" : "Создание"
    }, [params?.id])

    const showNamingSelect = useMemo(
        () => (["series"].includes(slug) ? slug : undefined),
        [slug]
    )

    return {
        showNamingSelect,
        pageTitle,
        id: params.id,
    }
}
